const RE_TITLE_CHARACTERS = /(?:^|\s|-)[a-z]/g;

export const TitleFilter = (text: string) => {
	// https://stackoverflow.com/a/64752866/356016
	return text.toLowerCase().replace(RE_TITLE_CHARACTERS, x => x.toUpperCase());
};
